module.exports = __webpack_public_path__ + "static/media/from-av4cus-text.5e24fab6.svg";